import { useSetAtom } from 'jotai';
import { sendCJToCMSPayloadAtom } from './atom';

export const useOpenCJSendToCMSModal = () => useSetAtom(sendCJToCMSPayloadAtom);
